<template>

  <div class="col-lg p-0 ml-4" style="background: none;">
        <feedbackStat />
        <improvementStat />
        <productivityStat />
        
      


  </div>
</template>

<script>
import feedbackStat from "@/components/engagement/profilePage/statistics/feedbackStat.vue";
import improvementStat from "@/components/engagement/profilePage/statistics/improvementStat.vue";
import productivityStat from "@/components/engagement/profilePage/statistics/productivityStat.vue";

export default {
  mixins: [],
  props: ["user"],
  components: {
      feedbackStat,
      improvementStat,
      productivityStat
      
  },

  mounted() {},
  methods: {
  },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeProfile.scss";
</style>